import { useState, useEffect } from "react";
import { Button, Box, Typography } from "@mui/material";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import Loader from '../../../../Components/Loader';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors'
import { ReusableTextInput, ReusableRadioGroup, FormRow } from '../../../../Components/Common Components/CommonRenderFields';
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents'
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { CheckAccessFunc } from "../../../../Components/CommonFunctions/CommonFunctions";

const initialState = {
  occupation: "",
  maritalStatus: "",
  pregnancy: "",
  children: "",
  dietType: "",
  dietTiming: "",
  tastePreference: "",
  appetite: "",
  bowels: "",
  sleepType: "",
  sleepDuration: "",
  daySleep: "",
  build: "",
  exerciseDaily: "",
  exerciseType: "",
  exerciseFrequency: "",
  exerciseLevel: "",
  dailyActivity: "",
  alcohol: "",
  smoking: "",
  drugs: "",
  temperament: "",
  saatmyam: "",
};

export default function DocSocialHistory(props) {
  const [state, setState] = useState({
    formData: initialState,
    isEditable: true,
    hasExistingData: false,
    withOutAppointment: {},
    doctor_id: "",
    patientDetails: {},
    clinicId: null,
    appointmentId: null,
    patientId: null,
    isLoader: false,
    selectedId: null,
  });

  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: message,
      transmit: false,
      saveLoad: false
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: message,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const LoaderFunction = (key) => {
    updateState({
      isLoader: key
    })
  }

  const { formData, isEditable, hasExistingData, patientDetails } = state;
  const updateState = (obj) => setState((prev) => ({ ...prev, ...obj }));

  // Load existing data
  useEffect(() => {
    const clinicId = getCachevalue("SelectedDoctorClinic");
    const appointmentData = JSON.parse(getCachevalue("DoctorPatientData"));
    const ipPatientData = JSON.parse(getCachevalue("IppatientData"));
    const appointmentDetail = JSON.parse(getCachevalue("withoutAppointment"));

    updateState({
      clinicId: clinicId,
      appointmentId: appointmentData?.appointment_id,
      patientId: appointmentData?.patient_id || ipPatientData?.patient_id,
      doctor_id: ipPatientData?.doctor_id,
      patientDetails: ipPatientData || appointmentData,
      withOutAppointment: appointmentDetail?.patient_id === ipPatientData?.patient_id
        ? appointmentDetail
        : null,
    })
  }, []);

  useEffect(() => {
    if (state.patientId) {
      if (!props.is_From_Fo) {
        getPatientDetailData();
      }
      getSocialHistoryData();
    }
  }, [state.patientId])

  const getPatientDetailData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + state.patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            updateState({
              patientDetails: { ...state.patientDetails, ...response?.data?.data }
            })
          }
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const getSocialHistoryData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_SOCIAL_HISTORY + '?patient_id=' + state.patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            const list = response?.data?.data
            if (list?.length > 0) {
              const item = list[0];
              const apiData = {
                "smoking": item?.smoking || "",
                "occupation": item?.occupation || "",
                "drugs": item?.drugs || "",
                "alcohol": item?.alcohol || "",

                "maritalStatus": item?.marital_status || "",
                "pregnancy": item?.pregnancy || "",
                "children": item?.children || "",

                "dietType": item?.diet_type || "",
                "dietTiming": item?.diet_timing || "",
                "tastePreference": item?.teste_preference || "",
                "appetite": item?.appetite || "",

                "bowels": item?.bowels || "",
                "sleepType": item?.sleep_type || "",
                "sleepDuration": item?.sleep_duration || "",
                "daySleep": item?.day_sleep || "",
                "build": item?.build || "",

                "exerciseDaily": item?.exercise_daily || "",
                "exerciseType": item?.exercies_type || "",
                "exerciseFrequency": item?.exercies_frequency || "",
                "exerciseLevel": item?.exercies_level || "",

                "dailyActivity": item?.rate_daily_active || "",
                "temperament": item?.temperament || "",
                "saatmyam": item?.saatmyam || ""
              }

              updateState({
                selectedId: item?.id,
                formData: apiData,
                isEditable: false,
                hasExistingData: true
              });
            }
          }
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (value.length <= 50) {
      setState((prev) => ({
        ...prev,
        formData: { ...prev.formData, [name]: value }
      }));
    }
  };

  const handleRadioChange = (name, value) => {
    setState((prev) => ({
      ...prev,
      formData: { ...prev.formData, [name]: value }
    }));
  };

  // Check if any field is filled
  const isAnyFieldFilled = Object.values(formData).some(
    (v) => v?.toString().trim().length > 0
  );

  // Clear all fields
  const handleClear = () => {
    setState((prev) => ({
      ...prev,
      formData: initialState
    }));
  };

  // Save or Update
  const handleSaveOrUpdate = () => {
    try {
      const { formData } = state;
      const data = {
        "id": state?.selectedId ?? undefined,
        "patient": state.patientId,
        "appointment": state.appointmentId,

        "smoking": formData?.smoking || "",
        "occupation": formData?.occupation || "",
        "drugs": formData?.drugs || "",
        "alcohol": formData?.alcohol || "",

        "marital_status": formData?.maritalStatus || "",
        "pregnancy": formData?.pregnancy || "",
        "children": formData?.children || "",

        "diet_type": formData?.dietType || "",
        "diet_timing": formData?.dietTiming || "",
        "teste_preference": formData?.tastePreference || "",
        "appetite": formData?.appetite || "",

        "bowels": formData?.bowels || "",
        "sleep_type": formData?.sleepType || "",
        "sleep_duration": formData?.sleepDuration || "",
        "day_sleep": formData?.daySleep || "",
        "build": formData?.build || "",

        "exercise_daily": formData?.exerciseDaily || "",
        "exercies_type": formData?.exerciseType || "",
        "exercies_frequency": formData?.exerciseFrequency || "",
        "exercies_level": formData?.exerciseLevel || "",

        "rate_daily_active": formData?.dailyActivity || "",
        "temperament": formData?.temperament || "",
        "saatmyam": formData?.saatmyam || ""
      }
      if (props.is_From_Fo) {
        data['doctor'] = state.doctor_id
      }
      LoaderFunction(true)
      RestAPIService.create(data, Serviceurls.DOC_SOCIAL_HISTORY)
        .then((response) => {
          if (response.data.status === 'success') {
            LoaderFunction(false)
            successMessage(response.data.message)
            getSocialHistoryData()
            setState((prev) => ({
              ...prev,
              isEditable: false,
              hasExistingData: true
            }));
          }
        }).catch((error) => {
          LoaderFunction(false)
          errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      LoaderFunction(false)
      errorMessage(error.message)
    }
  }

  // Button label logic
  const buttonLabel = !hasExistingData ? "Save" : isEditable ? "Update" : "Edit";

  const handleButtonClick = () => {
    if (buttonLabel === "Edit") {
      setState((prev) => ({ ...prev, isEditable: true }));
    } else {
      handleSaveOrUpdate();
    }
  };

  const enableAdd = !isAnyFieldFilled && !hasExistingData
  const checkuserAccess = (CheckAccessFunc("front_office", "In Patients", "History", "Social History", "SubTab")?.editAccess ?
    state.withOutAppointment?.is_ip || true && !enableAdd : !enableAdd);

  return (
    <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
      <Box component={'div'} display={'flex'}>
        <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
          <CommonPatientDetails data={patientDetails} showDetailed={true} fromDoctor={(props.is_From_Ip_AdmissionDetails || props.is_From_Fo) ? false : true} />
        </Box>
      </Box>
      <Box component={'div'} width={"100%"} mt={'0.5vw'} p={"0.625vw"} border={'1px solid lightgray'}>
        <Box component={'div'} height={'2vw'} display={'flex'} alignItems={'center'} justifyContent={"space-between"}>
          <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Social History</Typography>
          <div style={{ display: "flex", gap: "0.625vw" }}>
            <Button
              size="small"
              variant="outlined"
              disabled={!isAnyFieldFilled}
              onClick={handleClear}
            >
              Clear
            </Button>
            <Button
              size="small"
              variant="contained"
              disabled={props.is_From_Fo ? !checkuserAccess : enableAdd}
              onClick={handleButtonClick}
            >
              {buttonLabel}
            </Button>
          </div>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: "3vw",
            rowGap: "1vw",
            width: "100%",
            padding: "1vw",
            backgroundColor: Colors.white,
            marginTop: "0.625vw",
            height: "55vh",
            justifyContent: "center",
            overflowY: "auto"
          }}
        >
          <FormRow label="Occupation">
            <ReusableTextInput label="Occupation"
              name="occupation" value={formData.occupation}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Build">
            <ReusableTextInput label="Build"
              name="build" value={formData.build}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Marital Status">
            <ReusableRadioGroup name="maritalStatus"
              value={formData.maritalStatus} disabled={!isEditable}
              options={["Single", "Married", "Widow/Divorcee"]}
              onChange={handleRadioChange} />
          </FormRow>
          <FormRow label="Do You Exercise Daily?">
            <ReusableRadioGroup name="exerciseDaily"
              value={formData.exerciseDaily} disabled={!isEditable}
              options={["Yes", "No", "Rarely"]} onChange={handleRadioChange} />
          </FormRow>
          <FormRow label="Pregnancy">
            <ReusableTextInput label="Pregnancy"
              name="pregnancy" value={formData.pregnancy}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Exercise Type">
            <ReusableTextInput label="Exercise Type"
              name="exerciseType" value={formData.exerciseType}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Children">
            <ReusableTextInput label="Children"
              name="children" value={formData.children}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Exercise frequency">
            <ReusableTextInput label="Exercise frequency"
              name="exerciseFrequency" value={formData.exerciseFrequency}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Diet Type">
            <ReusableTextInput label="Diet Type"
              name="dietType" value={formData.dietType}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Exercise level">
            <ReusableTextInput label="Exercise level"
              name="exerciseLevel" value={formData.exerciseLevel}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Diet timing">
            <ReusableTextInput label="Diet timing"
              name="dietTiming" value={formData.dietTiming}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Rate your daily activity">
            <ReusableTextInput label="Rate your daily activity"
              name="dailyActivity" value={formData.dailyActivity}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Taste Preference">
            <ReusableTextInput label="Taste Preference"
              name="tastePreference" value={formData.tastePreference}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Alcohol">
            <ReusableTextInput label="Alcohol"
              name="alcohol" value={formData.alcohol}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Appetite">
            <ReusableTextInput label="Appetite"
              name="appetite" value={formData.appetite}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Smoking">
            <ReusableTextInput label="Smoking"
              name="smoking" value={formData.smoking}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Bowels">
            <ReusableTextInput label="Bowels"
              name="bowels" value={formData.bowels}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Drugs">
            <ReusableTextInput label="Drugs"
              name="drugs" value={formData.drugs}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Sleep type">
            <ReusableTextInput label="Sleep type"
              name="sleepType" value={formData.sleepType}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Temperament">
            <ReusableTextInput label="Temperament"
              name="temperament" value={formData.temperament}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Sleep Duration">
            <ReusableTextInput label="Sleep Duration"
              name="sleepDuration" value={formData.sleepDuration}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Saatmyam">
            <ReusableTextInput label="Saatmyam"
              name="saatmyam" value={formData.saatmyam}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
          <FormRow label="Day sleep ">
            <ReusableTextInput label="Day sleep "
              name="daySleep" value={formData.daySleep}
              disabled={!isEditable} onChange={handleInputChange} />
          </FormRow>
        </Box>
      </Box>
      {message.isErrorMsg && <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose.bind(this)} />}
      {message.successMsg && <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose.bind(this)} />}
      <Loader loaderOpen={state.isLoader} />
    </Box>
  );
}